import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { doLogOut, getWhoAmI } from '../auth/authActions'
import {
  getUserDto,
  hasAnyRole,
  isAuthenticated,
  isEmailVerificationInProgress,
  isSuperAdmin,
  getUserCompanies,
  hasRoleInCompany,
} from '../auth/authSelectors'
import { getCurrentRoute } from './RouterSelector'
import { IDispatchProps, IStateProps, Routes } from './Routes'
import { CompanyId, Role } from '../../services/api.types'
import { clearSuperAdminTargetCompany } from '../../views/SuperAdmin/store/SuperAdminActions'
import { getChatUnreadCount } from '../../views/Chat/store/ChatSelectors'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  hasAnyRole: (roles: Role[]) => hasAnyRole(state, roles),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  // Treat a mid-verification session as NOT authenticated for the Navbar / Routes UI, so the
  // profile dropdown and other authenticated navigation hide and the user can only interact
  // with the verify screen itself.
  authenticated: isAuthenticated(state) && !isEmailVerificationInProgress(state),
  currentRoute: getCurrentRoute(state),
  userDto: getUserDto(state),
  userCompanies: getUserCompanies(state),
  isSuperAdmin: isSuperAdmin(state),
  superAdminTargetCompanyName: state.superAdmin?.targetCompany?.companyName || null,
  chatUnreadCount: getChatUnreadCount(state),
})

const mapDispatchToProps: IDispatchProps = {
  doLogOut,
  getWhoAmI,
  clearSuperAdminTargetCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
